module.exports = __webpack_public_path__ + "static/media/continue.931d2e1c.svg";